@if (searchCriteria) {
  <div class="columns">
    <div class="column">
      <section class="section" [ngClass]="{'is-hidden': !noResultsFound}">
        <div class="container">
          <div class="subtitle has-text-centered">
            <h2 class="has-text-weight-bold">
              No results found. Please check your search criteria.
            </h2>
          </div>
        </div>
      </section>
      @if (results && results.length > 0) {
        <div class="search-result">
          <div class=" form-table-container">
            <table class="table is-fullwidth is-striped" ngClass="{{config.className || ''}}" role="grid">
              <thead>
                <tr role="row" class="is-selected">
                  @for (column of columns; track column) {
                    @if (column.display) {
                      <th class="table-header" [mcTableSorting]="config" [column]="column" title="{{column.title}}" (sortChanged)="onChangeTable($event)"
                        ngClass="{{column.className || ''}}">
                        <span> {{column.title}}</span>
                        @if (config && column.sort) {
                          <span class="sort  is-text-centered">
                            @if (column.sort === 'desc') {
                              <span>
                                <i class="fas fa-sort-down"></i>
                              </span>
                            }
                            @if (column.sort === 'asc') {
                              <span>
                                <i class="fas fa-sort-up"></i>
                              </span>
                            }
                          </span>
                        }
                      </th>
                    }
                  }
                </tr>
              </thead>
              <tbody>
                @for (row of rows; track row) {
                  <tr>
                    <td>
                      <span> {{row.referenceNumber}}</span>
                    </td>
                    <td>
                      <span> {{row.referenceType}}</span>
                    </td>
                    <td>
                      <a (click)="goToStudyLanding(row)">
                        <span class="is-size-6 has-text-weight-bold ">
                          {{row.studyNumber}}
                        </span>
                      </a>
                    </td>
                    <td>
                      <span> {{row.status.studyStatusDesc}}</span>
                    </td>
                    <td>
                      <span> {{row.studyType}}</span>
                    </td>
                    <td>
                      <span> {{row.acronym}}</span>
                    </td>
                    <td>
                      <span> {{row.longDescription}}</span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  </div>
}